import { LANDING_CLIPS } from './landingClips'

// Every production visual is composed from the curated FLUX.3 posters, not live UI.
// ponytail: index into LANDING_CLIPS by number; the contact sheet is the picker.
export const poster = (i: number) => LANDING_CLIPS[i % LANDING_CLIPS.length].poster

export function Still({ src, pos = '50% 50%', className = '' }: { src: string; pos?: string; className?: string }) {
  // eslint-disable-next-line @next/next/no-img-element -- static marketing still
  return <img src={src} alt="" className={`object-cover ${className}`} style={{ objectPosition: pos }} />
}

// One frame for every feature's visual so the mockups read as the same product.
export function Frame({ className = '', children }: { className?: string; children: React.ReactNode }) {
  return (
    <div
      className={`overflow-hidden rounded-xl border border-white/[0.09] bg-[#0e0e0e] shadow-[0_24px_60px_-30px_rgba(0,0,0,0.8)] ${className}`}
    >
      {children}
    </div>
  )
}
